<script lang="ts">
	export let siteName = "Empirical Research for Editors";
</script>

<header>
    <h1 class="title is-1">{siteName}</h1>
</header>

<style>
    header {
        padding-bottom: 1em;
    }
</style>
